import { useState, useEffect, useRef } from 'react';
import css from './index.module.scss';
import { EFCPAPH5, EFFishTankH5, EFWiFiRouterH5 } from '@/components/UI/svg/river2';
import { useGlobal } from '@/utils/useGlobal';
import { getImageSpec } from '@/utils/locals';
import EFVideo from '@/components/UI/EFVideo';
import EcoImg from 'eco-design/base/eco-img';

// 视频是否已播放
let hasNoneEnterPlayFlag = true;

export default function J() {
    const { useLang, useRouter } = useGlobal();
    const { t } = useLang('productriver2');
    const { locale } = useRouter();
    const imgSpec = getImageSpec(locale, ['cn', 'uk', 'de', 'fr', 'es', 'it', 'eu']);
    const [isEnterA, setIsEnterA] = useState(false);
    let icons: any = [
        { icon: <EFFishTankH5 width="0.52rem" height="0.52rem" />, text: t('river2.details.sec10_2_icon2') },
        { icon: <EFWiFiRouterH5 width="0.52rem" height="0.52rem" />, text: t('river2.details.sec10_2_icon3') },
    ];
    if (locale !== 'jp') {
        icons.unshift({ icon: <EFCPAPH5 width="0.52rem" height="0.52rem" />, text: t('river2.details.sec10_2_icon1') });
    }
    const videoRefB = useRef();

    const videoMap: any = {
        us: ['/video/river2/details/h5/10_us.webm', '/video/river2/details/h5/10_us.mp4'],
        cn: ['/video/river2/details/h5/10_cn.webm', '/video/river2/details/h5/10_cn.mp4'],
        eu: ['/video/river2/details/h5/10_eu.webm', '/video/river2/details/h5/10_eu.mp4'],
        de: ['/video/river2/details/h5/10_eu.webm', '/video/river2/details/h5/10_eu.mp4'],
        fr: ['/video/river2/details/h5/10_eu.webm', '/video/river2/details/h5/10_eu.mp4'],
        it: ['/video/river2/details/h5/10_eu.webm', '/video/river2/details/h5/10_eu.mp4'],
        es: ['/video/river2/details/h5/10_eu.webm', '/video/river2/details/h5/10_eu.mp4'],
        cis: ['/video/river2/details/h5/10_eu.webm', '/video/river2/details/h5/10_eu.mp4'],
        jp: ['/video/river2/details/h5/10_jp.webm', '/video/river2/details/h5/10_jp.mp4'],
        uk: ['/video/river2/details/h5/10_uk.webm', '/video/river2/details/h5/10_uk.mp4'],
        za: ['/video/river2/details/h5/10_za.webm', '/video/river2/details/h5/10_za.mp4'],
        au: ['/video/river2/details/h5/10_au.webm', '/video/river2/details/h5/10_au.mp4'],
        kr: ['/video/river2/details/h5/10_eu.webm', '/video/river2/details/h5/10_eu.mp4'],
    };

    useEffect(() => {
        const $videoDmo: any = document?.querySelector('#h5MVideoB');
        const sceneA1 = new ScrollMagic.Scene({
            triggerElement: '.river2_details_J .icons',
            triggerHook: 1, // 进入
            offset: 100,
            duration: '200%',
        });
        sceneA1.on('enter', () => {
            setIsEnterA(true);
            if ($videoDmo) {
                $videoDmo.currentTime = 0;
                hasNoneEnterPlayFlag = true;
            }
        });
        sceneA1.on('leave', () => {
            setIsEnterA(false);
        });
        sceneA1.addTo(AniContainer);
    }, []);

    // 播放视频
    useEffect(() => {
        const sceneA1 = new ScrollMagic.Scene({
            triggerElement: '#h5MVideoB',
            triggerHook: 0.5, // 进入
            offset: 0,
            duration: '200%',
        });
        sceneA1.on('enter', () => {
            if (hasNoneEnterPlayFlag) {
                videoRefB.current?.play();
                hasNoneEnterPlayFlag = false;
            }
        });
        sceneA1.addTo(AniContainer);
    }, []);

    if (locale === 'ph') {
        icons = [
            { icon: <img src="https://websiteoss.ecoflow.com/upload/image/1751080550221/Fan.png" />, text: t('river2.details.sec10_2_icon1') },
            { icon: <img src="https://websiteoss.ecoflow.com/upload/image/1751080550714/WIFI.png" />, text: t('river2.details.sec10_2_icon2') },
            { icon: <img src="https://websiteoss.ecoflow.com/upload/image/1751080549949/Desktop.png" />, text: t('river2.details.sec10_2_icon3') },
            { icon: <img src="https://websiteoss.ecoflow.com/upload/image/1751080550458/Refrigerator.png" />, text: t('river2.details.sec10_2_icon4') },
        ];
    }
    return (
        <div className={`river2_details_J ${css.J_10}`}>
            <div className={`innerBox`}>
                {['eu', 'uk', 'de', 'fr', 'it', 'es', 'us', 'ca', 'ph'].includes(locale) && (
                    <div className="sec2">
                        <div className="textBox">
                            <p className="red">{t('river2.details.sec10_2_red')}</p>
                            <p className="title">{t('river2.details.sec10_2_title')}</p>
                            <p className="desc">{t('river2.details.sec10_2_desc')}</p>
                            <ul className={`icons${isEnterA ? ' isEnterA' : ''}`}>
                                {icons?.map((icon: any, k: number) => (
                                    <li className={`iconList iconList-${k}`} key={k}>
                                        <div className="iconList-in">
                                            <div className="icon">{icon?.icon}</div>
                                            <p className="text">{icon?.text}</p>
                                        </div>
                                    </li>
                                ))}
                            </ul>
                        </div>
                        <div className="imgBox">
                            {locale === 'ph' ? (
                                <EcoImg pc="https://websiteoss.ecoflow.com/upload/image/1751272164728/b-h5.jpg" className="fullImgs" />
                            ) : (
                                <EFVideo
                                    sources={videoMap[locale] || videoMap.us}
                                    width="100%"
                                    height="100%"
                                    className="fullImgs"
                                    loop={false}
                                    autoPlay={false}
                                    ref={videoRefB}
                                    id="h5MVideoB"
                                    poster={`/media/river2/h5/J/10_${imgSpec}.jpg`}
                                />
                            )}
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
}
